module.exports = __webpack_public_path__ + "media/images/index/feature/top-coj-b-306214e76e8dc1e3c63076144a62ea32.png";